import { API } from "apis";
import CandidateItemListItem from "components/candidate-item/CandidateItemListItem";
import PageTitle from "components/common/PageTitle";
import QuoteRequestDialog from "components/dialog/QuoteRequestDialog";
import { CandidateItemModel, CandidateItemSetModel, ContextModel } from "models";
import React from "react";
import { Helmet } from "react-helmet-async";
import { useOutletContext } from "react-router-dom";
import { Utils } from "utils";

/** 「商談候補商品」画面 */
const CandidateItemPage: React.FC = () => {
  const ctx = useOutletContext<ContextModel>();
  const didEffect = React.useRef(false);

  const [data, setData] = React.useState<CandidateItemSetModel[]>([]);
  const [selectedList, setSelectedList] = React.useState<CandidateItemSetModel[]>([]);
  const [modalIsOpen, setIsOpen] = React.useState(false);

  const onChangeSelectedState = (item: CandidateItemSetModel, value: boolean) => {
    const idx = selectedList.indexOf(item);
    if (idx >= 0) {
      if (value === false) {
        selectedList.splice(idx, 1);
        setSelectedList(selectedList.concat());
      }
    } else {
      if (value === true) {
        const tmp = [];
        for (const i of data) {
          if (selectedList.includes(i)) {
            tmp.push(i);
          } else if (i === item) {
            tmp.push(i);
          }
        }
        setSelectedList(tmp);
      }
    }
  };

  const onDelete = async (target: CandidateItemModel) => {
    ctx.loading.setState(true);
    try {
      const response = await API.CandidateItem.del(target.candidate_item_cd);
      console.log(response);
      if (response.data.success) {
        // 再ロード
        const dataFilter = data.map((item) => {
          return {
            ...item,
            candidate_item_list: item.candidate_item_list.filter((i) => i.candidate_item_cd !== target.candidate_item_cd)
          }
        }).filter(o => o.candidate_item_list.length !== 0);
        setData(dataFilter);

        let tmp = selectedList.map((selected) => {
          return dataFilter.find((v: any) => v.corp_id === selected.corp_id);
        });
        tmp = tmp.filter((v) => v !== undefined);
        setSelectedList(tmp as CandidateItemSetModel[]);
      }
    } catch (err) {
      Utils.errorAction(ctx, err);
    }
    ctx.loading.setState(false);
  };

  const onCloseDialog = async (result: boolean) => {
    if (result) {
      ctx.loading.setState(true);
      try {
        const response = await API.CandidateItem.list();
        console.log(response);
        setData(response.data);
      } catch (err) {
        Utils.errorAction(ctx, err);
      }
      ctx.loading.setState(false);
    }
    setIsOpen(false);
    console.log("close " + result);
  };

  React.useEffect(() => {
    if (didEffect.current) {
      return;
    }
    didEffect.current = true;
    const f = async () => {
      ctx.loading.setState(true);
      await ctx.auth.initialize();

      try {
        const response = await API.CandidateItem.list();
        console.log(response);
        setData(response.data);
      } catch (err) {
        Utils.errorAction(ctx, err);
      }
      ctx.loading.setState(false);
    };
    f();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (data.length === 0) {
    return (
      <div className="">
        <Helmet>
          <title>商談候補商品</title>
        </Helmet>
        <PageTitle title="商談候補商品" className="p-2" />
        <div className="flex justify-center py-12">
          <div>商談候補商品がありません。</div>
        </div>
      </div>
    );
  }

  return (
    <div className="">
      <Helmet>
        <title>商談候補商品</title>
      </Helmet>
      <PageTitle title="商談候補商品" className="p-2" />
      <div className="p-4 flex flex-col gap-4">
        {data.map((item, index) => (
          <CandidateItemListItem
            key={index}
            item={item}
            selectedList={selectedList}
            onChangeSelectedState={onChangeSelectedState}
            onDelete={onDelete}
          />
        ))}
      </div>
      <div className="m-4 text-center p-8 bg-blue-200">
        <div>チェックした会社に</div>
        <div className="mt-4">
          <button
          className={`${selectedList.length === 0 ? 'secondary-disabled px-4 py-2 ' : 'secondary px-4 py-2 '}`}
            onClick={() => {
              const isInvalidQuantity = selectedList.some((item) =>
                item.candidate_item_list.some(
                  (v) => v.quantity < 1 || v.quantity > 9999
                )
              );
              if (isInvalidQuantity) {
                alert(
                  "数量は1〜9999以内の数字で入力してください"
                );
              } else {
                setIsOpen(true);
              }
            }}
            disabled={selectedList.length === 0}
          >
            まとめて見積依頼
          </button>
        </div>
      </div>
      <QuoteRequestDialog
        ctx={ctx}
        modalIsOpen={modalIsOpen}
        targets={selectedList}
        close={onCloseDialog}
      />
    </div>
  );
};
export default CandidateItemPage;
